module.exports = __webpack_public_path__ + "img/caratula_bambu_blurred2.04a4658b.jpeg";